// @ts-check
import { observer } from 'mobx-react-lite';
import React from 'react';
import { processBadgeDiscount } from 'src/scripts/templates/product-listing-page/PlpUtils/ProcessBadgeDiscount';
import { heapTrack } from 'src/scripts/utils/helpers';
import { extractProductIdFromDecodedGraphQLId } from '../../../../../utils/shopify';
import type { RecommendationServiceCarouselItemTypes } from './RecommendationServiceTypes';
import { getProductPrices } from '../helpers';
import { fireWidgetClickPixel } from 'src/scripts/utils/bloomreach-recommendations';
import { CarouselItemPrice } from 'src/scripts/templates/_shared/ui-components/CarouselItemPrice/CarouselItemPrice';
import { gatedSaleState } from '../../GatedSaleProductPrice/state';
import { Badge } from 'src/scripts/templates/product-listing-page/components/Badge';

let RecommendationServiceCarouselItem = ({
  data,
  blockTitle,
  brRecommendationMetadata,
}: RecommendationServiceCarouselItemTypes) => {
  const productPrice = Math.trunc(data.priceRange.maxVariantPrice.amount);
  const productCompareAtPrice = Math.trunc(data.compareAtPriceRange.maxVariantPrice.amount);
  const [price, compareAtPrice] = getProductPrices(data.tags, productPrice, productCompareAtPrice);

  const title = data.title;
  const handle = data.handle;
  const imgSrc = data.images[0];

  const productId = Number(extractProductIdFromDecodedGraphQLId(data.gid));
  const handleProductClick = () => {
    heapTrack(`PDP - Click - Item in Carousel`, {
      productId,
      carousel: blockTitle,
    });

    fireWidgetClickPixel({
      wrid: brRecommendationMetadata?.widget?.rid ?? 'br_ext',
      wid: brRecommendationMetadata?.widget?.id ?? 'br_ext',
      wty: brRecommendationMetadata?.widget?.type ?? 'br_ext',
      item_id: productId.toString(),
    });
  };

  const isOnSale = compareAtPrice && compareAtPrice > price;
  const { isEnabled: hardMarkSaleEnabled } = gatedSaleState.hardMarkSaleConfig;

  let badgeDiscount = isOnSale && compareAtPrice ? processBadgeDiscount(compareAtPrice, price) : null;
  if (hardMarkSaleEnabled && badgeDiscount) {
    badgeDiscount = badgeDiscount?.replace('Off', '');
  }

  //const titleLength = isMobile ? 37 : 30;

  return (
    <div className="product-carousel--wrapper insta-product crosssell-product">
      <a href={`/products/${handle}`} onClick={handleProductClick}>
        <img className="img-fluid product-carousel-image" src={imgSrc || ''} alt={title} />
      </a>
      {badgeDiscount ? <Badge badgeCopy={badgeDiscount} isDiscountBadge={true} /> : null}
      <a href={`/products/${data.handle}`} onClick={handleProductClick}>
        <p className="product-name product-carousel-title">{title}</p>
      </a>
      <CarouselItemPrice price={price} compareAtPrice={compareAtPrice} productType={data.productType} />
    </div>
  );
};
RecommendationServiceCarouselItem = observer(RecommendationServiceCarouselItem);

export default RecommendationServiceCarouselItem;
